import { gql, TypedDocumentNode } from '@common/hooks';

type LastSubmittalResponseType = {
  staffingRequestApplication: {
    id: string;
    lastOfferChangeResponse?: {
      id: string;
      createdAt: string;
      offerChangeRequest: {
        id: string;
        createdAt: string;
      };
    };
  };
};

export const SUBMITTAL_PACKET_LAST_UPDATED_INFO_QUERY: TypedDocumentNode<LastSubmittalResponseType> = gql`
  query LastSubmittalResponse($id: ID!) {
    staffingRequestApplication(id: $id) {
      id
      lastOfferChangeResponse {
        id
        createdAt
        offerChangeRequest {
          id
          createdAt
        }
      }
    }
  }
`;
